export default __webpack_public_path__ + "static/media/map.77b836a7.png";